import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtroClientes'
})
export class FiltroClientesPipe implements PipeTransform {

  transform(arreglo: any[], texto: string, ): any[] {
   
   // console.log(objeto)

    if(texto ===''){
      return arreglo
    }
    if( arreglo.length === 0 ) {
      return arreglo;
    }

    texto = texto.toLocaleLowerCase()

    return arreglo.filter (item=>{


    
   

          //console.log(enmascaramiento)
      //console.log(item.id)
      if(item.registrosCliente.nombre){
       // console.log('caso 1');
        return item.numeroCliente.toLocaleLowerCase().includes(texto) || item.registrosCliente.nombre.toLocaleLowerCase().includes(texto) || item.id.toString().includes(texto)

      }

    // else  if(enmascaramiento && !item.registrosCliente.nombre){
    //     console.log('caso dos');
    //     return item.id
    //   }
      
      else{
     
      return  item.numeroCliente.toLocaleLowerCase().includes(texto) || item.id.toString().includes(texto)
    }

     
     
    })
   
    return arreglo;
  }

}
